import { useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { ToggleButtonGroup, ToggleButton } from '@mui/material/index'
import Search from './Search'
import Profile from './Profile'
import Notification from './Notification'
import MobileSection from './MobileSection'
import axios from 'axios'

const edit = async (api, data) => {
    await axios
        .put(`${process.env.REACT_APP_API_URL + api}`, data)
        .then((res) => {
            try {
                if (res?.data?.result) load_data()
            } catch (error) {
                console.log('error : ' + api + '!')
            }
        })
        .catch(() => console.log('error!'))
}

const HeaderContent = () => {
    const [first_effect, set_first_effect] = useState(true)
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'))
    const [company, set_companies] = useState(JSON.parse(localStorage.getItem("company")));
    const [status_id, set_status_id] = useState(JSON.parse(localStorage.getItem("company"))?.status_id)
    const [statuses, set_statuses] = useState([])
    const [companies, setCompanies] = useState([])
    const [user, set_user] = useState(JSON.parse(localStorage.getItem("user")));
    const [settings, set_settings] = useState({
        order_by: 'name',
        per_page: 50,
        order_desc: false,
        filters: {
            type: 10,
        }
    })

    useEffect(() => {
        load_data()
        statuses_load()
    }, [])

    useEffect(() => {
        load_company()
        new Promise((resolve, reject) => {
            setTimeout(() => {
                load_company()
            }, 3000);
        });
        localStorage.setItem("user", JSON.stringify(user ?? {}));
    }, [user])

    const load_company = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}users`, {
                with: ['company'],
                filters: {
                    id: JSON.parse(localStorage.getItem("user") ?? {})?.id,
                }
            })
            .then((res) => {
                try {
                    // console.log(res?.data?.data?.[0]?.company?.id)
                    // console.log(company?.id)
                    if (res?.data?.data?.[0]?.company?.id != company?.id) {
                        localStorage.setItem("company", JSON.stringify(res?.data?.data?.[0]?.company ?? {}))
                        location.pathname = '/datamanaging/companies'
                        set_company(res?.data?.data?.[0]?.company)
                    }
                } catch (error) {
                    console.log('error : ' + 'companies' + '!')
                }
            })
            .catch(() => console.log('error!'))
    }

    const load_data = () => {
        axios
            .post(`${process.env.REACT_APP_API_URL}companies`, settings)
            .then((res) => {
                try {
                    setCompanies(res?.data?.data)
                } catch (error) {
                    console.log('error : ' + 'companies' + '!')
                }
            })
            .catch(() => console.log('error!'))
    }

    function statuses_load() {
        axios
            .post(`${process.env.REACT_APP_API_URL}statuses`, { per_page: 10, filters: { model_type: 'App\\Models\\Company' } })
            .then((res) => {
                try {
                    set_statuses(res?.data?.data)
                } catch (error) {
                    console.log('Error : statuses')
                }
            })
            .catch(() => console.log('error!'))
    }

    useEffect(() => {
        if (!first_effect) {
            edit('companies', { id: company?.id, status_id: status_id })
            set_statuses(statuses.map(s => s?.id == status_id ? { ...s, selected: true } : { ...s, selected: false }))
            set_companies({ ...company, status_id: status_id })
            localStorage.setItem("company", JSON.stringify({ ...company, status_id: status_id }));
            setTimeout(() => {
                statuses_load()
            }, 1000);
        } else set_first_effect(false)
    }, [status_id])

    return (
        <>
            {/* {!matchesXs && <Search />} */}
            {!matchesXs &&
                <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
                    <ToggleButtonGroup key='1' exclusive sx={{ whiteSpace: 'nowrap' }} aria-label="text alignment"
                        onChange={(e, v) => {
                            edit('users', { id: user?.id ?? 0, company_id: v })
                            set_user(u => ({ ...u, company_id: v }));
                        }}
                    >
                        {companies && companies.map((s, i) =>
                            <ToggleButton sx={{ fontSize: 8, color: '#000', p: 1 }} selected={s?.id == company?.id} key={i} value={s?.id}>{s?.name}</ToggleButton>
                        )}
                    </ToggleButtonGroup>
                </Box>
            }
            {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

            {statuses &&
                <ToggleButtonGroup key='2' exclusive sx={{ whiteSpace: 'nowrap' }} aria-label="text alignment"
                    onChange={(e, v) => set_status_id(v)}
                >
                    {statuses && statuses.map((s, i) =>
                        <ToggleButton selected={s?.selected} key={i} value={s?.id}>{s?.value}</ToggleButton>
                    )}
                </ToggleButtonGroup>
            }

            {/* <Notification /> */}
            {!matchesXs && <Profile />}
            {matchesXs && <MobileSection />}
        </>
    )
}

export default HeaderContent
